import { render, staticRenderFns } from "./OrganisationEditor.vue?vue&type=template&id=fb6d3ef0"
import script from "./OrganisationEditor.vue?vue&type=script&lang=ts"
export * from "./OrganisationEditor.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationEditor.vue?vue&type=style&index=0&id=fb6d3ef0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports